module.exports = __webpack_public_path__ + "static/media/stepTwo.c60ee08a.png";